<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <!-- LANGUAGE -->
        <v-row>
          <v-col class="pb-0">
            <v-icon class="mr-2">mdi-translate</v-icon>
            <label>{{ $t("settings.lang") }}</label>
            <v-col />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0">
            <v-select
              v-model="getLang"
              :items="languages"
              solo
              flat
              @input="localChanged"
            />
          </v-col>
        </v-row>
        <!-- THEME -->
        <v-row>
          <v-col class="pb-0">
            <v-icon class="mr-2">mdi-compare</v-icon>
            <label>{{ $t("settings.theme") }}</label>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-list width="100%">
              <v-list-item-group
                v-model="getDarkTheme"
                mandatory
              >
                <template v-for="theme in $t('settings.themes')">
                  <v-list-item
                    :key="theme.value"
                    :value="theme.value"
                    active-class="primary"
                    @click="themeChanged(theme.value)"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="accent-4"
                          @click="themeChanged(theme.value)"
                        />
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title v-text="theme.text" />
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
        <!-- DISPLAY -->
        <v-row>
          <v-col class="mt-4 pb-0">
            <v-icon class="mr-2">mdi-shape</v-icon>
            <label>{{ $t("settings.display") }}</label>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-list>
              <!-- ICON SIZE -->
              <v-list-item>
                <v-list-item-content id="size-icon-content">
                  <v-list-item-title>{{ $t("settings.size-icon") }}</v-list-item-title>
                  <v-list-item-subtitle>{{ $t("settings.size-icon-subtitle") }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action id="size-icon-action">
                  <v-slider
                    v-model="getIconSize"
                    step="5"
                    :min="25"
                    :max="45"
                    ticks="always"
                    thumb-label
                  />
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <v-row v-if="false">
          <v-col>
            <v-list>
              <!-- BOTTOM BAR -->
              <v-list-item @click="toggleBottomBar">
                <v-list-item-content>
                  <v-list-item-title>{{ $t("settings.bottombar") }}</v-list-item-title>
                  <v-list-item-subtitle>{{ $t("settings.bottombar-subtitle") }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch :input-value="model_bar" />
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      languages: [
        { text: "Français", value: "fr" },
        { text: "English", value: "en" },
      ],
      model_bar: true,
    };
  },
  computed: {
    getDarkTheme: {
      get: function () {
        return this.$store.state.config.prefs.darkTheme === "true";
      },
      set: function (theme) {
        this.$store.dispatch("setDarkTheme", theme).config;
        localStorage.darkTheme = theme;
      },
    },
    getIconSize: {
      get: function () {
        return this.$store.state.config.prefs.iconSize;
      },
      set: function (size) {
        this.$store.dispatch("setIconSize", size).config;
        localStorage.iconSize = size;
      },
    },
    getLang: {
      get: function () {
        return this.$store.state.config.prefs.lang;
      },
      set: function (lang) {
        this.$store.dispatch("setLang", lang).config;
        localStorage.lang = lang;
      },
    },
  },
  created() {
    document.title = this.$t("navbar.settings") + " · " + this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("navbar.settings"));
  },
  mounted() {
    // Restore current bottom bar visibility
    this.model_bar = this.$store.state.config.prefs.bottomNavbar;
  },
  methods: {
    localChanged(val) {
      this.$i18n.locale = val;
    },
    themeChanged(val) {
      this.$vuetify.theme.dark = val;
    },
    toggleBottomBar() {
      this.model_bar = !this.model_bar;
      this.$store.dispatch("toggleBottomBar");
    },
  },
};
</script>

<style>
#size-icon-content {
  flex: 0.3 1;
}

#size-icon-action {
  flex: 0.7 1;
}
</style>
